import { render, staticRenderFns } from "./BaseOpenService.vue?vue&type=template&id=04724230&scoped=true"
import script from "./BaseOpenService.vue?vue&type=script&lang=js"
export * from "./BaseOpenService.vue?vue&type=script&lang=js"
import style0 from "./BaseOpenService.vue?vue&type=style&index=0&id=04724230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04724230",
  null
  
)

export default component.exports